import useSWR from 'swr';
import { createFetcher } from './Requests';
import { ErrorRes, Result } from '../types';

// eslint-disable-next-line import/prefer-default-export
export const fetchResultDetails = (resultId: string) => {
  const { url, fetcher } = createFetcher(`/results/${resultId}`);
  return { swr: useSWR<Result, ErrorRes>(url, fetcher), url };
};
